 :sm="6" :xs="6"<template>
    <div class="device-type-manange relative">
        <div class="buttons">
<!--            <el-button @click="resetForm">重置</el-button>-->
<!--            <el-button @click="search">筛选</el-button>-->
            <el-button @click="addGroupChat">创建群聊</el-button>
        </div>

        <!-- 表单开始 -->
        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="6" :xl="4" :sm="6" :xs="6">
                <span class="fs-14 pd-r-10">群主姓名：</span>
                <el-input v-model="user_name" placeholder="姓名模糊搜索"/>
            </el-col>
            <el-col :md="6" :lg="6" :xl="4" :sm="6" :xs="6">
                <span class="fs-14 pd-r-10">群名称：</span>
                <el-input v-model="chatroom_name" placeholder="群名称模糊搜索"/>
            </el-col>
            <el-col :md="6" :lg="6" :xl="4" :sm="6" :xs="6">
                <el-button @click="resetForm">重置</el-button>
                <el-button @click="search">筛选</el-button>
            </el-col>
        </el-row>
        <!-- 表单结束 -->

        <el-table ref="multipleTable"
                  :data="tableData"
                  border
                  style="width: 100%">
            <el-table-column prop="user_name" label="群主" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="chatroom_name" label="群名称" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="member_count" label="成员数" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="create_date" label="创建时间" align="center" label-class-name="label"></el-table-column>
            <el-table-column
                    prop="address"
                    label="操作"
                    align="center"
                    label-class-name="label"
                    v-slot="scope"
            >
                <el-button :id="'doctorEdit'" @click="getGroupMember(scope.row)"
                           type="text" size="mini">查看成员
                </el-button>
                <el-button :id="'doctorEdit'" @click="goGroupLogList(scope.row)"
                           type="text" size="mini">查看聊天记录
                </el-button>
                <el-button :id="'doctorEdit'" @click="changeGroupLeader(scope.row)"
                           type="text" size="mini">更换群主
                </el-button>
                <el-button :id="'doctorEdit'" @click="deleteGroup(scope.row)"
                           type="text" size="mini">删除该群
                </el-button>
            </el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
        ></el-pagination>

        <el-dialog title="更换群主" :visible.sync="dialogFormVisible">
            <el-form :model="form" style="width: 40%;margin: 20px auto 0 auto;" :rules="rules" ref="form">
                <el-form-item label="选择群主:" :label-width="formLabelWidth" prop="user_id">
                    <el-select v-model="form.user_id" placeholder="请选择" style="width: 100%;" filterable>
                        <el-option-group
                                v-for="group in allChangeUserData"
                                :key="group.label"
                                :label="group.label">
                            <el-option
                                    v-for="item in group.options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-option-group>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="changeGroupLeaderConfirm('form')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import {export2Excel} from "@/utils/excel";
    import env from "@/api/env";
    import {check} from "@/utils/checkData";

    export default {
        data() {
            return {
                allChangeUserData: [],
                formLabelWidth: '120px',
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                allRole: [
                    {
                        id: 1,
                        name: '特属服务对象'
                    },
                    {
                        id: 3,
                        name: '特属专家'
                    },
                ],
                user_name: '',
                chatroom_name: '',
                dialogFormVisible: false,
                form: {
                    user_id: '',
                },
                rules: {
                    user_id: [
                        {required: true, message: "请选择群主", trigger: "blur"},
                    ],
                },
                changeChatroomId: '',
            };
        },
        created() {

        },
        mounted() {
            // 获取群聊列表
            this.getList();
            localStorage.setItem('prev_page', 'groupchat_list')
        },
        methods: {
            getList() {
                let params = {
                    servername: 'Ruyi_chatAdminServices',
                    method: 'GroupList',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        user_name: this.user_name,
                        chatroom_name: this.chatroom_name,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;
                });
            },

            getAllChatGroupMember(user_id, chatroom_id) {
                let params = {
                    servername: 'Ruyi_chatAdminServices',
                    method: 'changeGroupLeaderParams',
                    params: {
                        user_id: user_id,
                        chatroom_id: chatroom_id,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.allChangeUserData = res.data.data;
                    this.dialogFormVisible = true;
                });
            },

            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            // 重置按钮
            resetForm() {
                this.user_name = "";
                this.chatroom_name = "";
                this.page = 1;
                this.getList();
            },

            // 搜索
            search() {
                this.page = 1;
                this.getList();
            },

            // 编辑
            goEdit(data) {
                this.$router.push({
                    name: "oneChatFiendList", params: {
                        user_id: data.user_id,
                        own_name: data.user_name
                    }
                });
            },

            // 查看群成员
            getGroupMember(data) {
                this.$router.push({
                    name: "groupChatMemberList", params: {
                        chatroom_id: data.chatroom_id,
                        chatroom_name:data.chatroom_name,
                    }
                });
            },

            changeGroupLeader(data) {
                this.getAllChatGroupMember(data.user_id, data.chatroom_id);
                this.changeChatroomId = data.chatroom_id;
                this.form.user_id = '';
            },

            changeGroupLeaderConfirm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        let params = {
                            servername: 'Ruyi_chatAdminServices',
                            method: 'changeGroupLeader',
                            params: {
                                user_id: this.form.user_id,
                                chatroom_id: this.changeChatroomId,
                            }
                        };
                        this.$api.service(params).then(res => {
                            if (!check(res)) {
                                return;
                            }
                            if (res.data.code == '0') {
                                this.$message({
                                    type: "success",
                                    message: '更换成功'
                                });
                                this.dialogFormVisible = false;
                                this.getList();
                            }
                        });
                    } else {
                        this.$message({
                            type: "error",
                            message: '请选择群主'
                        });
                        return false;
                    }
                });
            },

            goGroupLogList(data) {
                this.$router.push({
                    name: "groupChatLogDetail", params: {
                        chatroom_id: data.chatroom_id,
                        chatroom_name: data.chatroom_name
                    }
                });
            },

            addGroupChat() {
                this.$router.push({
                    name: "addGroupChat", params: {}
                });
            },

            deleteGroup(data) {
                this.$confirm('确定删除该群吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        servername: 'Ruyi_chatAdminServices',
                        method: 'delGroup',
                        params: {
                            chatroom_id: data.chatroom_id,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            return;
                        }
                        if (res.data.code != '0') {
                            this.$message({
                                type: 'error',
                                message: res.data.msg
                            });
                            return;
                        }
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.getList();
                    });

                    /*this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });*/
                }).catch(() => {
                });
            }
        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .docker_buttons {
        float: right;
        margin: 30px 0px 8px 0px;

        .el-button {
            width: 150px;
            height: 32px;
            line-height: 7px;
        }
    }
</style>
